module.exports = __webpack_public_path__ + "img/down.7e823cdb.svg";